var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "url(#pattern0_641_464)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_641_464",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_641_464",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_641_464",
    width: 32,
    height: 32,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAn1JREFUWIXllz1rFFEUhp9zZ9cgaogQzGQzu9roFURRjI1ViggWaRJBSJVCG/EfCGkMWFjaCIJFKlEJkk6w0MJYRJAEm0zwI242axICimgRk51jsZPdcfeO5e6CpzrDfc553/k4w73wv4cABMGJgR0jVyQi1wpRNZSzkc6USstr0p+3gxG8EOhphXgivonIJe9Qd+9ThOMtFgfYr3DKqHC+DeIACAwaoKtdBoCuTM2N8gYj0y5KVc8CNwAUeWaE5y4uUi4LOhpf3heRBadspBMqXASoGVCYXS8uPXDxuZy1kVc1ADr9tRjOuri+vN0ARgGMp/fKK+GSi/MD2wNVA8bpsIXROQZUJJMGVTyTrRVoOpdcq+zWaxojqSV+3mqcb6G8QlBHzUngdJyvAG9Tel8AjsX5e6D5G1AEYQjobTTQlkg+zp9AmML1AUGcbwFfUrijxHcGlICNFM4CBxsN3F1fDadc9JHAnjHCIgDCzfVi+MTF+QV7FeUxQBTpyOba8qKTy9tJ4DYkp0DZTnFLJqqv6T+45Fomm84ltTpnDNsV9XkUHfYL9rMLUtVz8d4FQcb8gt3n7KYyQjzFumsm/IJ958JEdVj3+rV7DDvoFaCPKkSTIqb5iagMCTyMuTuRVPPGMMo1RW4BqHIdoy+bWmkkHmZKkfG/DKjKwmbpw0dX41zOZiOvmkfI/EYx/OTi+vJ2XuLcy+hceWXZyfmBXUAYhw54BR1hYBtARFO35RUxh/dyEUnlkmu7O/WaZq6mtS39gZ2L92cKfE+pOQDszX4F+JHCdQPx18Jv4FcK10P1x/K67QeT+tEMMyboQCuUFVmriM5srYblVuh1dvwBEQPKSjLaX8QAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoi);
export default __webpack_public_path__ + "static/media/roi.771db5cb4b1523479424a614d93b42d2.svg";
export { ForwardRef as ReactComponent };